import type { ClientMediaItem } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, type FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { ChatMessageImage } from '@/features/chats/components/ChatMessageImage';
import { useAppNavigation } from '@/navigation/hooks/useAppNavigation';
import { AppRoute } from '@/navigation/types/navigation';

const styles = StyleSheet.create({
  container: { flexDirection: 'column', alignItems: 'stretch' }
});

type Props = {
  mediaItems: ClientMediaItem[];
};

export const ChatMessageImages: FC<Props> = ({ mediaItems }) => {
  const navigation = useAppNavigation();

  const handleOpenGallery = useCallback(
    (position = 0) => {
      navigation.navigate(AppRoute.Gallery, {
        position,
        mediaUrls: mediaItems.map(({ urls }) => urls.original)
      });
    },
    [mediaItems, navigation]
  );

  return (
    <View style={styles.container}>
      {mediaItems.map((mediaItem, index) => (
        <ChatMessageImage
          key={mediaItem.id}
          mediaItem={mediaItem}
          onMediaItemPress={() => handleOpenGallery(index)}
        />
      ))}
    </View>
  );
};
